<template>
    <div class="card-primary">
        <p class="text-xxxl text-bold">Projects</p>
            <div class="card-primary-scroll-small" v-if="projects.length > 0">
                    <carousel class="card-projects " :items="3" :nav="false" :dots="false" :autoplay="true" :loop="true" :autoplayTimeout="10000">
                        <div v-for="projectList in projects" :key="projectList.id">
                            <div class="card-secondary-project mt-20">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="text-big" v-bind:id="'role-'+projectList.id" v-for="members in projectList.members" :key="members.name">
                                            <!-- role diproject -->
                                            <!-- <span  > -->
                                                <template v-if="members.name == $route.params.name ">
                                                    <div class="row" >
                                                        <div class="col-12" v-for="(roles, index) in members.roles" :key="`roles-${index}`">
                                                             <p  class="text-m text-bold text-bold2">
                                                                {{roles.name}}
                                                            </p>
                                                        </div>
                                                    </div>
                                            </template>
                                        </div>
                                        <br>
                                        <!-- router link -->
                                        <span class="text-bold" style=" color:black; text-decoration: none; !important"><p class="text-xxxl text-extrabold">{{projectList.name}}</p></span>
                                        <br>
                                        <div class="col-4 card-blue-xxs mt-10">
                                            <div class="row">
                                                <div class="col-11">
                                                    <p class="text-xxl text-bold">New Issue:</p>
                                                </div>
                                                <div class="col-1">
                                                    <p class="text-xxl text-bold">{{projectList.status_count.New}}</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4 card-yellow-xxs mt-10">
                                        <div class="row">
                                            <div class="col-11">
                                                <p class="text-xxl text-bold">In Progress Issue:</p>
                                            </div>
                                            <div class="col-1">
                                                <p class="text-xxl text-bold">{{projectList.status_count.Feedback + projectList.status_count['In Progress']}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4 card-green-xxs mt-10">
                                        <div class="row">
                                            <div class="col-11">
                                                <p class="text-xxl text-bold">Clossed Issue:</p>
                                            </div>
                                            <div class="col-1">
                                                <p class="text-xxl text-bold">{{projectList.status_count.Closed}}</p>
                                            </div>
                                        </div>
                                    </div>

                                     <div style="row">
                                        <div class="col-12 card-secondary-xxs mt-20">
                                            <div class="row">
                                                <div class="col-11">
                                                    <p class="text-xxxl text-bold text-bold2">Total Issue:</p>
                                                </div>
                                                <div class="col-1">
                                                    <p class="text-xxxl text-bold text-bold2">{{projectList.status_count.Closed + projectList.status_count.Feedback + projectList.status_count.New + projectList.status_count['In Progress']}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        
                    </carousel>
            </div>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
    name:"Project",
    components:{
        carousel
    },
    props:['projects'],
}
</script>

<style scoped>
    .text-bold2 {
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/User/Project.vue